"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var toQueryParam = function (key, val) {
    return encodeURIComponent(key) + "=" + encodeURIComponent(val);
};
exports.toQueryParam = toQueryParam;
// tslint:disable-next-line:no-any
var makeQueryParam = function (key, val) {
    if (typeof val === 'object') {
        var toKey = function (objKey) { return encodeURIComponent(key) + "." + objKey + "=" + encodeURIComponent(val[objKey]); };
        return ramda_1.pipe(ramda_1.map(toKey), ramda_1.join('&'))(ramda_1.keys(val));
    }
    return toQueryParam(key, val);
};
exports.makeQueryParam = makeQueryParam;
//# sourceMappingURL=helpers.js.map